import axios from 'axios';

export const API_URL = 'https://mensajes.arifamilyassets.com';
export const SOCKET_URL = 'https://mensajes.arifamilyassets.com';

// ─── Autenticación ──────────────────────────────────────────────────────────

export const loginUser = async (credentials) => {
    try {
        const response = await axios.post(`${API_URL}/auth/login`, {
            usuario: credentials.username,
            password: credentials.password,
        });
        return response.data;
    } catch (error) {
        throw (error.response && error.response.data) || error;
    }
};

export const registerUser = async (userData) => {
    try {
        const response = await axios.post(`${API_URL}/auth/register`, {
            usuario: userData.username,
            password: userData.password,
        });
        return response.data;
    } catch (error) {
        throw (error.response && error.response.data) || error;
    }
};

// ─── Grupos / Chats ────────────────────────────────────────────────────

export const fetchChatList = async () => {
    try {
        const response = await axios.get(`${API_URL}/chat/groups`);
        return response.data.map((g) => ({
            id: g.id,
            title: g.name,
            lastMessage: '',
        }));
    } catch (error) {
        throw (error.response && error.response.data) || error;
    }
};

// ─── Mensajes ────────────────────────────────────────────────────────────

export const fetchMessages = async (groupId) => {
    try {
        const response = await axios.get(`${API_URL}/chat/groups/${groupId}/messages`);
        return response.data;
    } catch (error) {
        throw (error.response && error.response.data) || error;
    }
};

export const createGroup = async (name, ownerId) => {
    try {
        const response = await axios.post(`${API_URL}/chat/groups`, {
            name,
            owner_id: ownerId,
        });
        return response.data;
    } catch (error) {
        throw (error.response && error.response.data) || error;
    }
};

export const sendMessage = async (groupId, content, userId) => {
    try {
        const response = await axios.post(`${API_URL}/chat/messages`, {
            group_id: groupId,
            user_id: userId,
            content,
        });
        return response.data;
    } catch (error) {
        throw (error.response && error.response.data) || error;
    }
};